var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        openModalChangeCountry: _vm.isOpenChangeCountryModal,
        hasChangedData: ""
      },
      on: {
        "update:openModalChangeCountry": function($event) {
          _vm.isOpenChangeCountryModal = $event
        },
        "update:open-modal-change-country": function($event) {
          _vm.isOpenChangeCountryModal = $event
        },
        confirmChangeFlag: _vm.handleConfirmChangeFlag
      }
    },
    [
      _c(
        "div",
        { staticClass: "ep__main_content pt-80" },
        [
          _c(
            "section",
            { staticClass: "content", attrs: { "data-form-container": "" } },
            [
              _c(
                "div",
                { staticClass: "container p-0" },
                [
                  _c("EpPageTitle", { staticClass: "font-36 mb-0 pb-32" }, [
                    _vm._v(" QR Code ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "row d-flex justify-content-between mb-88" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-lg-5 col-12 margin-bottom-16 p-0" },
                        [
                          _c("div", { staticClass: "row m-0" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-lg-12 col-md-6 col-6",
                                class: {
                                  "col-md-12 col-12": !_vm.isShowBankingOnlineNote
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content__frame d-flex flex-column pb-0 pl-24 pt-32 h-100"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form__valid row m-0 pb-32"
                                      },
                                      [
                                        _c("div", { staticClass: "font-16" }, [
                                          _c("span", { staticClass: "mr-24" }, [
                                            _vm._v("Transaction ID:")
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "form__txtAmount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.createdPaymentTransaction
                                                    .transactionUid
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form__valid row m-0 pb-32 font-16"
                                      },
                                      [
                                        _c("span", { staticClass: "mr-32" }, [
                                          _vm._v("Total Amount:")
                                        ]),
                                        _c(
                                          "span",
                                          { staticClass: "form__txtAmount" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.createdPaymentTransaction
                                                  .currency
                                              ) + " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "form__txtAmount ml-2",
                                            attrs: { "data-testid": "amount" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(this.formattedTotalAmount)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm.isShowBankingOnlineNote
                              ? _c(
                                  "div",
                                  { staticClass: "col-lg-12 col-md-6" },
                                  [
                                    _c("BankingOnlineNote", {
                                      on: {
                                        clickHereBankingOnlinePayNow:
                                          _vm.handleClickhereBankingOnlinePayNow
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _c("div", { staticClass: "col-lg-7 col-12" }, [
                        _c("div", { staticClass: "content__frame p-0" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-items-center"
                            },
                            [
                              _c(
                                "EpLabel",
                                {
                                  staticClass:
                                    "form__valid mt-56 mb-48 font-18 txt-gray"
                                },
                                [
                                  _vm._v(
                                    "Please open your bank app to scan QR code"
                                  )
                                ]
                              ),
                              _c("div", { staticClass: "qrcode" }, [
                                _c("img", {
                                  attrs: {
                                    "data-testid": "qrCodeImage",
                                    src:
                                      "data:image/jpeg;base64," +
                                      _vm.createdPaymentTransaction.qrCode,
                                    alt: "",
                                    height: "280",
                                    width: "280"
                                  }
                                })
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form__valid mt-40 mb-40 row expired-text"
                                },
                                [
                                  _c("div", {}, [
                                    _vm._v(
                                      "Your QR code will be expired after:"
                                    )
                                  ]),
                                  _c("EpCountDown", {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: { expiry: _vm.qrCodeExpiry },
                                    on: { timeout: _vm.handleQrCodeExpire }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn--main btn--blue btn--sm-scr save-btn mb-56 cancel-button",
                                  attrs: {
                                    type: "button",
                                    "data-testid": "cancelButton"
                                  },
                                  on: { click: _vm.handleCancelButtonClick }
                                },
                                [_vm._v(" Cancel ")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c("CancelDialog", {
            attrs: {
              isOpen: _vm.isCancelModalOpen,
              closeOnClickOutside: false
            },
            on: {
              discard: _vm.handleDiscardCancel,
              confirm: _vm.handleConfirmCancel
            }
          }),
          _c("EpQrCodeExpired", {
            attrs: {
              isOpen: _vm.isExpiredModalOpen,
              closeOnClickOutside: false
            },
            on: {
              retry: _vm.handleRetryTransaction,
              newPayment: _vm.handleNewPayment
            }
          }),
          _vm.successData
            ? _c(
                "EpPaymentSuccess",
                _vm._b(
                  {
                    on: {
                      newPayment: _vm.handleNavigateToNewPayment,
                      homePage: _vm.handleNavigateToHomepage
                    }
                  },
                  "EpPaymentSuccess",
                  Object.assign(
                    {},
                    { isOpen: _vm.isShowPaymentSuccess },
                    _vm.successData,
                    { country: _vm.country }
                  ),
                  false
                )
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }